import React from 'react';
import {ProjectAuditsApiService} from '@lib/api-services/AuditsApiService';
import buildResourcePath from '@lib/buildResourcePath';
import AuditIndexPage from '../audits/AuditIndexPage';
import AuditIndexPageTitle from '../audits/AuditIndexPageTitle';

class ProjectAuditPage extends React.Component {

    renderTitleComponentClass = () => {
        return <AuditIndexPageTitle
            title={this.props.options.title}
            url={buildResourcePath(`/Project/Edit/${this.props.filter.hiddenFilters.entityId}`)}
        />
    }

    render() {
        return (
            <AuditIndexPage {...this.props} titleComponentClass={() => this.renderTitleComponentClass()}
                            indexApiService={ProjectAuditsApiService}/>
        );
    }
}

window.components.ProjectAuditPage = ProjectAuditPage